"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebouncedCallback = void 0;
var lodash_1 = require("lodash");
var react_1 = require("react");
function noop() { }
function createDebouncedCallback(fn, duration) {
    return duration ? (0, lodash_1.debounce)(fn, duration) : fn;
}
function useDebouncedCallback(fn, duration) {
    var callbackFn = fn || noop;
    var callbackRef = (0, react_1.useRef)(createDebouncedCallback(callbackFn, duration));
    (0, react_1.useEffect)(function () {
        callbackRef.current = createDebouncedCallback(callbackFn, duration);
        return function () {
            if (callbackRef.current) {
                if ('cancel' in callbackRef.current) {
                    callbackRef.current.cancel();
                }
                callbackRef.current = null;
            }
        };
    }, [callbackFn, duration]);
    return callbackRef.current;
}
exports.useDebouncedCallback = useDebouncedCallback;
//# sourceMappingURL=debounced-callback.js.map